import { Link } from "react-router-dom";
import { site } from "@/mocks/site";
import { events } from "@/mocks/events";

const tileStyles = [
  "from-primary-500 to-primary-400 text-background-50",
  "from-accent-500 to-accent-400 text-background-50",
  "from-secondary-500 to-secondary-400 text-background-50",
  "from-primary-600 to-accent-500 text-background-50",
];

export default function Categories() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
          瓜田分布 · SECTIONS
        </p>
        <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          按栏目选个瓜田逛逛
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
          不同领域的话题节奏不同，进入对应栏目能更快找到你关心的那类整理。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {site.categories.map((cat, i) => {
          const count = events.filter((e) => e.categorySlug === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/events?cat=${cat.slug}`}
              className={`group relative overflow-hidden rounded-lg bg-gradient-to-br p-6 ${tileStyles[i % tileStyles.length]} transition-transform hover:-translate-y-1`}
            >
              <span className="absolute -right-5 -top-6 font-heading text-[7rem] font-black leading-none text-white/10 select-none">
                {count}
              </span>
              <span className="relative">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-50/20 backdrop-blur">
                  <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="mt-4 block font-heading text-xl font-bold">{cat.name}</span>
                <span className="mt-2 block min-h-[3rem] text-sm leading-relaxed text-background-50/90">
                  {cat.desc}
                </span>
                <span className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-background-50/20 px-3 py-1 text-xs font-medium">
                  {count} 份事件地图
                  <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}